import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

import {
    DeliverableCardFile,
    DeliverableCardPayload,
} from '../../../../services/ai-poc/ai-poc.service';

/**
 * Inline rendering of a `build_document` tool result inside the Gable chat — a
 * generated deliverable (board summary .docx/.pdf) shown as a header (blue icon
 * chip + title + subtitle) over a single primary Download button. When more than
 * one format exists the button opens a mat-menu of formats (the app-wide dropdown
 * pattern); a single format downloads directly. Signed URLs render as plain
 * anchors so they open straight from chat.
 */
@Component({
    selector: 'app-gable-deliverable-card',
    templateUrl: './deliverable-card.component.html',
    styleUrls: ['./deliverable-card.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatButtonModule, MatMenuModule],
})
export class GableDeliverableCardComponent {
    @Input({ required: true }) payload!: DeliverableCardPayload;

    get title(): string {
        return this.payload?.title ?? 'Document';
    }

    get files(): DeliverableCardFile[] {
        return this.payload?.files ?? [];
    }

    get primaryFile(): DeliverableCardFile | null {
        return this.files[0] ?? null;
    }

    iconFor(format: string): string {
        switch ((format ?? '').toLowerCase()) {
            case 'pdf':
                return 'ph-file-pdf';
            case 'docx':
            case 'doc':
                return 'ph-file-doc';
            default:
                return 'ph-file';
        }
    }

    formatLabel(format: string): string {
        switch ((format ?? '').toLowerCase()) {
            case 'pdf':
                return 'PDF (.pdf)';
            case 'docx':
            case 'doc':
                return 'Word (.docx)';
            default:
                return (format ?? '').toUpperCase();
        }
    }

    trackByFormat(_index: number, file: DeliverableCardFile): string {
        return file.format;
    }
}
